export default "__VITE_ASSET__BAtpCIFt__"